import requestCaptchaPasswordReset from 'src/dataLayer/remoteData/babbelAPI/requestCaptchaPasswordReset'
import useAsyncData from 'src/viewLayer/components/hooks/useAsyncData'

export default function useHandleCaptchaPasswordResetRequest() {
  const { data, inProgress, makeRequest } = useAsyncData(() => requestCaptchaPasswordReset())

  return {
    captchaConfig: data || null,
    captchaPasswordResetRequestInProgress: inProgress,
    makeCaptchaPasswordResetRequest: makeRequest,
  }
}
